// noinspection NonAsciiCharacters,JSNonASCIINames

export const translation_ja = {
    // beforeLogin
    "ログイン": "ログイン",

    // dashboard
    "ログアウト": "ログアウト",
    "新規作成": "新規作成",
    "編集": "編集",
    "共有": "共有",
    "複製": "複製",
    "のコピー": "{{value}} のコピー",
    "削除": "削除",
    "プライベート" : "プライベート",
    "共有中" : "共有中",

    // dashboard/削除確認ダイアログ
    "削除確認": "削除確認",
    "復元できません。本当に削除しますか？" : "復元できません。本当に削除しますか？",
    "キャンセル": "キャンセル",

    // dashboard/アクセス権を削除確認ダイアログ
    "「マップ名」へのアクセス権を本当に削除しますか？": "「{{value}}」へのアクセス権を本当に削除しますか？",
    "あなた": "あなた",

    // dashboard/footer
    "トップ": "トップ",
    "運営": "運営",
    "利用規約": "利用規約",
    "プライバシーポリシー": "プライバシーポリシー",
    "お問い合わせ": "お問い合わせ",

    // tooltip
    "ダッシュボード": "ダッシュボード",
    "一つ戻す": "一つ戻す",
    "一つ進む": "一つ進む",
    "フォント": "フォント",
    "文字サイズ": "文字サイズ",
    "テキストの色": "テキストの色",
    "太字": "太字",
    "左寄せ": "左寄せ",
    "中央寄せ": "中央寄せ",
    "右寄せ": "右寄せ",
    "選択したセルとひとつ右のセルを結合": "選択したセルとひとつ右のセルを結合",
    "選択した結合セルの最も右のセルを結合解除": "選択した結合セルの最も右のセルを結合解除",
    "全て表示": "全て表示",
    "背景を選択": "背景を選択",
    "配色を選択": "配色を選択",
    "オンラインN人": "オンライン {{value}}人",
    "ズーム": "ズーム",
    "ペルソナ設定": "ペルソナ設定",

// header toolbar
    "ゴシック": "ゴシック",
    "明朝": "明朝",
    // ----
    "小": "小",
    "標準": "標準",
    "大": "大",
    "特大": "特大",
    // ----
    "列・行を追加": "列・行を追加",
    "列を追加": "列を追加",
    "左に追加": "左に追加",
    "右に追加": "右に追加",
    "行を追加": "行を追加",
    "フロー行を上に追加": "フロー行を上に追加",
    "フロー行を下に追加": "フロー行を下に追加",
    "空白行を上に追加": "空白行を上に追加",
    "空白行を下に追加": "空白行を下に追加",
    "行動行を上に追加": "行動行を上に追加",
    "行動行を下に追加": "行動行を下に追加",
    "施策行を上に追加": "施策行を上に追加",
    "施策行を下に追加": "施策行を下に追加",

    // ----
    "背景": "背景",
    "配色": "配色",
    "ショートカット": "ショートカット",
    "共有設定": "共有設定",
    "画像(png)でダウンロード": "画像(png)でダウンロード",

    // map
    "ファネル": "ファネル",
    "1行表示": "1行表示",
    "2行表示": "2行表示",

    // grab ui
    "左右移動": "左右移動",
    "上下移動": "上下移動",
    "表示": "表示",
    "非表示": "非表示",
    //"削除": "削除",
    "追加": "追加",

    "説明を追加": "説明を追加",

    // collaborator
    "共有ユーザ設定": "共有ユーザ設定",
    "共有するユーザ、リストを入力": "共有するユーザ、リストを入力",
    "リストに追加": "リストに追加",
    "オーナー": "オーナー",
    "編集者": "編集者",
    "閲覧者": "閲覧者",
    "アクセス権を削除": "アクセス権を削除",
    "設定を更新": "設定を更新",

    "マップの削除、共有ユーザの追加や権限の変更はオーナーのみが行えます": "マップの削除、共有ユーザの追加や権限の変更はオーナーのみが行えます",
    "オーナーからあなたに共有されたマップの共有を拒否する場合は『「アクセス権」削除』を選択してください": "オーナーからあなたに共有されたマップの共有を拒否する場合は『「アクセス権」削除』を選択してください",

    "オンラインユーザー": "オンラインユーザー",

    // shortcut
    "キーボードショートカット": "キーボードショートカット",
}
